import { keyframes, styled } from "styled-components";

const skeletonLoading = keyframes`
  from {
    background-color: #c8c8db;
  }
  to {

    background-color: #ededf3;

  }
`;

export const Text = styled.div`
  width: ${(p) => (p.$marketplace ? "unset" : "75px")};
  border-radius: ${(p) => (p.$marketplace ? "9999px" : "10px")};
  height: ${(p) => (p.$marketplace ? "unset" : "10px")};
  padding: ${(p) => (p.$marketplace ? "8px 24px" : "0px")};
  color: transparent;
  font-family: "Avenir-Medium";
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500;
  user-select: none;
  animation: ${skeletonLoading} 0.6s linear infinite alternate;
`;
